import { twMerge } from '@tuic/tailwind-config';

import type { FC, HTMLAttributes } from 'react';

export const Badge: FC<HTMLAttributes<HTMLDivElement>> = props => {
  const { className, ...rest } = props;
  return (
    <div
      className={twMerge(
        'rounded-full size-[24px] bg-surface-secondary-100 text-xs text-white text-center pt-[2px]',
        className,
      )}
      {...rest}
    />
  );
};
